import React, { useEffect, useRef } from 'react'
import { ExternalPath } from 'src/modules/path'

type Props = {
  customScheme: string
  fallbackUrl?: string
  disableFallback?: boolean
}

export const AppCustomUrlSchemeLauncher: React.FC<Props> = ({
  customScheme,
  fallbackUrl = ExternalPath.lp,
  disableFallback = false
}) => {
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null)
  const attemptInitiatedRef = useRef(false) // 処理が開始されたかを管理するフラグ

  useEffect(() => {
    if (typeof window === 'undefined') return

    // 既に試行が開始されている場合、または必要なURLがない場合は何もしない
    if (attemptInitiatedRef.current || !customScheme || !fallbackUrl) {
      return
    }
    attemptInitiatedRef.current = true // 処理開始をマーク

    // アプリを開く試み
    window.location.href = customScheme

    // フォールバック用のタイマーを設定
    timeoutRef.current = setTimeout(() => {
      // タイムアウトが発生したらフォールバックURLに遷移
      if (disableFallback) return
      window.location.href = fallbackUrl
    }, 2000)

    const handleVisibilityChange = () => {
      // ページが非表示になったら (アプリが前面に来た可能性が高い)
      if (document.hidden) {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current)
          timeoutRef.current = null
        }
      }
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)

    // コンポーネントのアンマウント時にイベントリスナーとタイマーをクリーンアップ
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)

      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [customScheme, fallbackUrl, disableFallback])

  return null
}
